import React from 'react'
import { useTranslation } from "react-i18next";

const Title = (props) => {
  const { t } = useTranslation();

  return (
    <h3>{t(props.title)}</h3>
  )
};

export default Title;